import { __read } from "tslib";
export var setChartSettings = function (_a) {
    var keys = _a.keys;
    var _b = __read(keys, 3), xDomainKey = _b[0], yDomainKey = _b[1], valueKey = _b[2];
    return {
        xDomainKey: xDomainKey,
        yDomainKey: yDomainKey,
        valueKey: valueKey,
    };
};
